import { Panel } from '../panel.class';
import { PanelConnectionType } from '../enums';
import { Panels } from '../panels.class';

export const buildCornerIslandPanelsCfn = (panels: Panels): string => {
	// console.log('buildCornerIslandPanels');

	const frontPanel = new Panel({ parent: panels, dataIn: { label: 'front' }});
	const backLeftPanel = new Panel({ parent: panels, dataIn: { label: 'back left' }});
	const backRightPanel = new Panel({ parent: panels, dataIn: { label: 'back right' }});
	const leftPanel = new Panel({ parent: panels, dataIn: { label: 'left' }});
	const rightPanel = new Panel({ parent: panels, dataIn: { label: 'right' }});

	frontPanel.connectLeftSideToPanel(leftPanel, PanelConnectionType.Inside, 45, PanelConnectionType.Inside);
	leftPanel.connectLeftSideToPanel(backLeftPanel, PanelConnectionType.Outside, 90);
	backLeftPanel.connectLeftSideToPanel(backRightPanel, PanelConnectionType.Inside, 90);
	backRightPanel.connectLeftSideToPanel(rightPanel, PanelConnectionType.Inside, 90);
	rightPanel.connectLeftSideToPanel(frontPanel, PanelConnectionType.Inside, 45, PanelConnectionType.Inside);

	panels.children.push(frontPanel, leftPanel, backLeftPanel, backRightPanel, rightPanel);
	return frontPanel.id;
};
